/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Widget/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import * as fromFormat from 'Data/format.js'
import Ach from './Ach/index'
import Card from './Card/index'
import No from './No/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Widget({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/PaymentsTreatmentPlan/Content/TreatmentPayments/Content/Content/SetupPayment/ActiveStep/AutopaymentSetup/Pay/ChooseType/Widget"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let payersActivetabInstallmentMetadataTypeValueData = fromData.useDataFormat({ viewPath,
context: 'payers',
path: 'activeTab.installment_metadata.type',
format: fromFormat.capitalize,
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: payersActivetabInstallmentMetadataTypeValueData,
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Card'}>
<Card
  viewPath={`${viewPath}/Card`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Ach'}>
<Ach
  viewPath={`${viewPath}/Ach`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}